import React, { useEffect, useRef, useCallback, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid, Typography } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import NumberInput from '../Input/NumberInput';
import ButtonAction from '../Button.js/SaveButton';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const DrawerModal = ({
    visible = false,
    dataUpdate,
    setVisible,
    idCabinet,
    fuctGet,
    idPermission,
    isEdit,
    typeCabinet,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = React.useRef(false);
    const [name, setName] = useState('');
    const [quantityCol, setQuantityCol] = useState('0');
    const [quantityRow, setQuantityRow] = useState('0');

    const [code, setcode] = useState('');

    // console.log("modal", dataUpdate?.cabinet_type);
    // console.log("row", quantityRow, idPermission, idCabinet, typeCabinet);

    useEffect(() => {
        if (isEdit) {
            setName(dataUpdate.drawer_nm);
            setQuantityCol(dataUpdate.cells_x);
            setcode(dataUpdate.drawer_lc);
            setQuantityRow(dataUpdate.cells_y);
        } else {
            setName('');
            if (typeCabinet === 'square') {
                setQuantityCol('0');
                setQuantityRow('0');
            } else {
                setQuantityCol('0');
                setQuantityRow('1');
            }
            setcode('');
        }
    }, [dataUpdate]);

    const handleEdit = () => {
        if (addCabinetFlag.current === true) return;
        if (!name || !code || !quantityRow || !quantityCol) return toast.error(t('error.param'));

        addCabinetFlag.current = true;
        setFlagAddStat(true);

        if (isEdit) {
            let InVal = [+idPermission, dataUpdate.cabinet_id, name, +code, +quantityCol, +quantityRow, dataUpdate.id];
            // console.log("E", InVal)
            sendRequest(serviceList.updatedrawer, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            let InVal = [+idPermission, +idCabinet, name, +code, +quantityCol, +quantityRow];
            // console.log(InVal)
            sendRequest(serviceList.createdrawer, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();

            setVisible(!visible);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {isEdit ? t('Edit_drawer') : t('add_drawer')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={12} md={6} sm={6}>
                        <TextInput label={t('name_drawer')} valueChange={name} getValue={setName} required autoFocus />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={12} md={6} sm={6}>
                        <NumberInput label={'ID' + ' ' + t('drawer')} valueChange={code} required getValue={setcode} />
                    </Grid>
                    {typeCabinet === 'square' ? (
                        <>
                            <Grid item style={{ width: '100%' }} xl={12} md={6} sm={6}>
                                <NumberInput
                                    disabled={dataUpdate.cells_x ? true : false}
                                    label={t('no_row')}
                                    valueChange={quantityRow}
                                    required
                                    getValue={setQuantityRow}
                                />
                            </Grid>{' '}
                            <Grid item style={{ width: '100%' }} xl={12} md={6} sm={6}>
                                <NumberInput
                                    label={t('no_column')}
                                    valueChange={quantityCol}
                                    disabled={dataUpdate.cells_y ? true : false}
                                    required
                                    getValue={setQuantityCol}
                                />
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid item style={{ width: '100%' }} xl={12} md={12} sm={6}>
                                <NumberInput
                                    disabled={dataUpdate.cells_x ? true : false}
                                    label={t('total_cell')}
                                    valueChange={quantityCol}
                                    required
                                    getValue={setQuantityCol}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default DrawerModal;
